import React from 'react';

import { isNumber } from 'lodash-es';
import { useIntl } from 'react-intl';

import { primitive } from 'styles/constants/primitives';

import {
  PointsNeededContainer,
  PointsNeededDescription,
  PointsNeededLockIcon,
  PointsNeededText,
  StyledPointsIcon,
  StyledProgressMeter,
} from './loyalty-rewards.styled';
import { MeterContainer, RewardCategoryMeterContainer } from './loyalty-rewards.styled';
import { ILoyaltyRewardsMeter } from './types';

export const LoyaltyRewardsMeter: React.FC<ILoyaltyRewardsMeter> = ({
  redemptionPercentage,
  remainingPointsNeededForRedemption,
}) => {
  const { formatMessage } = useIntl();

  return (
    <RewardCategoryMeterContainer>
      {isNumber(redemptionPercentage) && (
        <MeterContainer>
          <PointsNeededLockIcon />
          <StyledProgressMeter
            percentage={redemptionPercentage}
            _progress={{ background: primitive.bk.$meltyYellow }}
          />
        </MeterContainer>
      )}
      {remainingPointsNeededForRedemption && (
        <PointsNeededContainer>
          <StyledPointsIcon></StyledPointsIcon>
          <PointsNeededText>{remainingPointsNeededForRedemption}</PointsNeededText>
          <PointsNeededDescription>
            {formatMessage({ id: 'crownsAwayFromUnlockingMoreRewards' })}
          </PointsNeededDescription>
        </PointsNeededContainer>
      )}
    </RewardCategoryMeterContainer>
  );
};
